
import React from 'react';
import { FaEnvelope } from 'react-icons/fa'; 
import './ContactInfoBlock.css'; 

const ContactInfoBlock = () => {
  return (
    <div className="_cIB_a8G_"> 
      <h2 className="_iTitle_b9H_">Get in Touch</h2> 

      <div className="_iItem_c0I_"> 
        <span className="_iLabel_d1J_">Email:</span> 
        <div className="_iContW_e2K_"> 
          <FaEnvelope className="_iIcon_f3L_" />
          <a href="mailto:info@vanidya.com" className="_iLink_g4M_">
            info@vanidya.com
          </a>
        </div>
      </div>


      <p className="_iDiscl_i6O_"> 
        We typically reply within 1 business day.
      </p>
    </div>
  );
};

export default ContactInfoBlock;
